import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import icon from "../../../Assets/Profile/profileicon/Icon.png";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import DataTableComponent from "../../../components/DataTable";
import {
  deleteUserManagementData,
  fetchUserManagementData,
} from "../../../redux/slice/UserManagementSlice";
import InfoModal from "../../../components/Common/InfoModal";
import Loader from "../../../components/Common/Loader/PrimaryLoader";
import UpdateUserStatusModal from "../../../components/Common/UpdateUserStatusModal";
import DeleteConFirmationModal from "../../../components/Common/DeleteConFirmationModal";
import { RxTriangleDown } from "react-icons/rx";
import { usePic } from "../../../context/PicProvider";
import { successStatusCode } from "../../../utils/constants";

function DistributorUserManagement() {
  const [userListModal, setUserListModal] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [confirmUpdateModal, setConfirmUpdateModal] = useState(false);
  const [modalConfirmTitle, setModalConfirmTitle] = useState("");
  const [userInfo, setUserInfo] = useState({});
  const [showDropCon, setShowDropCon] = useState(false);
  const [downDrop, setDownDrop] = useState(false);
  const [customClass, setCustomClass] = useState("");
  const [removeId, setRemoveId] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setIsLoading } = usePic();
  const { status, UserManagementData } = useSelector(
    (state) => state.USERMANAGEMENT
  );

  const userStatusUpdateHandler = async (id) => {
    toast.success("User Status Updated Successfully");
    setConfirmUpdateModal(false);
    setDeleteConfirm(false);
  };
  const clickRowHandler = (row) => {
    setUserInfo(row);
    navigate(`/distributor-update-distributor-user/${row._id}`, { state: row });
  };
  const onSelectedCheckboxChange = (check) => {
    const selectedId = check?.selectedRows.map((curElm) => curElm._id);
    if (selectedId.length > 0) {
      setRemoveId(selectedId);
      setShowDropCon(true);
    } else {
      setRemoveId([]);
      setShowDropCon(false);
    }
  };

  const downIconHandler = () => {
    setDownDrop(!downDrop);
  };

  const removeUserHandler = async () => {
    setIsLoading(true);
    const result = await dispatch(
      deleteUserManagementData({ userIds: removeId })
    );
    setIsLoading(false);
    const res = result?.payload;
    if (res?.status === successStatusCode) {
      dispatch(fetchUserManagementData());
      setDeleteConfirm(false);
      setShowDropCon(false);
      setDownDrop(false);
      setRemoveId([]);
    }
  };

  const deleteHandler = () => {
    setDeleteConfirm(true);
    setModalConfirmTitle("Are you sure you want to delete this user ?");
  };

  const handleCustomClassForUnderLine = (num) => {
    setCustomClass(num);
  };

  useEffect(() => {
    dispatch(fetchUserManagementData());
  }, [dispatch]);

  const userColumns = [
    {
      name: "",
      selector: (row) => (
        <img
          src={row.profile_pic ? row.profile_pic : icon}
          alt={row.lastName}
          className="products-image"
        />
      ),
      width: "80px",
    },
    {
      name: (
        <span
          className={customClass === "2" ? "custom-span-style-for-sorting" : ""}
          onClick={() => handleCustomClassForUnderLine("2")}
        >
          First Name
        </span>
      ),
      selector: (row) => row.first_name,
      sortable: true,
    },
    {
      name: (
        <span
          className={customClass === "1" ? "custom-span-style-for-sorting" : ""}
          onClick={() => handleCustomClassForUnderLine("1")}
        >
          Last Name
        </span>
      ),
      selector: (row) => row.last_name,
      sortable: true,
    },
    {
      name: (
        <span
          className={customClass === "3" ? "custom-span-style-for-sorting" : ""}
          onClick={() => handleCustomClassForUnderLine("3")}
        >
          Job Title
        </span>
      ),
      selector: (row) => row.job_title,
      sortable: true,
    },
    {
      name: (
        <span
          className={customClass === "4" ? "custom-span-style-for-sorting" : ""}
          onClick={() => handleCustomClassForUnderLine("4")}
        >
          Location
        </span>
      ),
      selector: (row) => row.location_name,
      sortable: true,
    },
    // {
    //   name: (
    //     <span
    //       className={customClass === "5" ? "custom-span-style-for-sorting" : ""}
    //       onClick={() => handleCustomClassForUnderLine("5")}
    //     >
    //       {" "}
    //       Area
    //     </span>
    //   ),
    //   // selector: (row) => row.company_name,
    //   sortable: true,
    // },
    // {
    //   name: (
    //     <span
    //       className={customClass === "6" ? "custom-span-style-for-sorting" : ""}
    //       onClick={() => handleCustomClassForUnderLine("6")}
    //     >
    //       Role
    //     </span>
    //   ),
    //   selector: (row) => row.assigned_role,
    //   sortable: true,
    // },
    {
      name: (
        <span
          className={customClass === "6" ? "custom-span-style-for-sorting" : ""}
          onClick={() => handleCustomClassForUnderLine("6")}
        >
          Role
        </span>
      ),
      selector: (row) => {
        if (row.assigned_role === "distributor_superadmin") {
          return "Super Admin";
        } else if (row.assigned_role === "distributor_salesrepresentative") {
          return "Sales Executive";
        } else {
          return row.assigned_role;
        }
      },
      sortable: true,
    },

    // {
    //   name: "Action",
    //   selector: (row) => (
    //     <div className="d-flex d-none">
    //       <NavLink
    //         className={"btn btn-sm btn-info me-2"}
    //         to={`/update-user/${row._id}`}
    //       >
    //         <FaEdit />
    //       </NavLink>
    //       <button
    //         className={"btn btn-sm btn-danger"}
    //         onClick={() => removeUserHandler(row._id)}
    //       >
    //         <FaRegTrashAlt />
    //       </button>
    //     </div>
    //   ),
    // },
  ];
  if (status === "loading") {
    return (
      <div>
        <Loader />
      </div>
    );
  }
  const userData = UserManagementData || [];

  return (
    <div className=" position-relative flex-grow-1">
      {userData && userData.length > 0 && showDropCon && (
        <div className="dropdown_icon_style">
          <div onClick={() => downIconHandler()}>
            <RxTriangleDown size={23} />
          </div>
          {downDrop && (
            <div className="event-box-data-user-event-listing">
              <h6 className="cursor" onClick={() => deleteHandler()}>
                Delete
              </h6>
            </div>
          )}
        </div>
      )}
      <DataTableComponent
        search={true}
        searchBy={["email", "first_name", "job_title"]}
        title={"Team Management"}
        columns={userColumns}
        data={userData}
        selectedRows
        clickedRow={clickRowHandler}
        checkboxChange={onSelectedCheckboxChange}
        placeholder="Search for team"
      />
      {userListModal && (
        <InfoModal
          hide={() => setUserListModal(false)}
          show={userListModal}
          title={"User Information"}
          listingData={userInfo}
        />
      )}
      {deleteConfirm && (
        <DeleteConFirmationModal
          show={deleteConfirm}
          title={modalConfirmTitle}
          eventHandler={removeUserHandler}
          hide={() => setDeleteConfirm(false)}
        />
      )}

      {confirmUpdateModal && (
        <UpdateUserStatusModal
          show={confirmUpdateModal}
          title={modalConfirmTitle}
          eventHandler={userStatusUpdateHandler}
          hide={() => setConfirmUpdateModal(false)}
        />
      )}
    </div>
  );
}
export default DistributorUserManagement;
// export default DistributorUsermanagement;
